import React from "react"
import {FieldInlineEditableProps} from "../../../../render/inline-editable";
import {findDOMNode} from "react-dom";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";
import ExpenseStatusSelectorPopover from "../../../../../gd-ui/select-status/expenses/popover";

// const debug = "FieldExpenseStatus_InlineEditable"
const debug = false

export default class FieldExpenseStatus_InlineEditable extends React.Component<FieldInlineEditableProps, any> {

    constructor(props:FieldInlineEditableProps) {
        super(props)

        this.state = {
            isHovered: false,
            showPopover: false
        }
    }

    onMouseEnter = () => {
        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueChange = (value: ID, hidePopover:boolean=true) => {

        // @ts-ignore
        this.props.onChange(value)

        hidePopover && this.hidePopover()
    }

    onClick = () => {
    //     if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderValue() {
        const status = this.props.model.approvalStatus
        const statusOption = this.props.field.options?.find((option)=>option.value === status)

        return (
            <div className={Classes('ui5-status-list', 'status-c{0}'.f(statusOption?.color), this.props.className)}>
                <div className="max-w-100-percent txt-truncate">{statusOption?.label}</div>
            </div>
        )
    }

    renderHovered() {
        return (
            <div className="ui5-field-dropdown-inline-editable is-hovered" onClick={this.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {this.renderValue()}
                <div className="buttons flex-no-shrink">
                    <div className="btn-arrow"/>
                </div>

                {this.state.showPopover &&
                    <ExpenseStatusSelectorPopover  field={this.props.field}
                                                   hidePopover={this.hidePopover}
                                                   onStatusSelect={this.onValueChange}
                                                   togglePopover={this.hidePopover}
                                                   hint={true}
                                                   popoverPosition={PopoverPosition.top()}
                                                   getTarget={()=>findDOMNode(this)}/>
                }
            </div>
        )
    }

    renderNotHovered() {
        return (
            <div className="ui5-field-dropdown-inline-editable" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {this.renderValue()}
            </div>
        )
    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered)   return this.renderHovered()
        else                        return this.renderNotHovered()
    }
}



